import { render } from "./ProporsionOfFailedVsFinishedChartContainer.vue?vue&type=template&id=168d7240"
import script from "./ProporsionOfFailedVsFinishedChartContainer.vue?vue&type=script&lang=js"
export * from "./ProporsionOfFailedVsFinishedChartContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__